<template>
  <section :class="getComponentClass(blok)">
    <component
      :is="'a_imageSource' | dashify"
      v-if="blok.image"
      :blok="setImageFormatting(blok)"
      :image-url="blok.image[0].image"
      :alt="blok.title"
      :modifier-class="'capabilities__bg'"
    />
    <div class="capabilities__container container">
      <div class="row">
        <div class="col-12">
          <h2 class="capabilities__title">{{ blok.title }}</h2>
          <component
            :is="'a_genericText' | dashify"
            :blok="blok.content[0]"
            modifier-class="capabilities__copy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Capabilities',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {}
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
      }
    },
  },
  methods: {
    getComponentClass(blok) {
      const shadow = blok.hasShadow ? ' capabilities--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      const space = blok.space ? `space--${blok.space}` : 'space--small'
      return `capabilities ${shadow} ${height} ${space}`
    },
    setImageFormatting(content) {
      return {
        image: content.image,
        isHScreen: content.isHScreen,
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.capabilities {
  position: relative;
  overflow: hidden;
  color: $white;
  background-image: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0) 87%
  );

  &.h-default {
    min-height: 300px;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &__container {
    position: relative;
    z-index: 1;
  }

  .media-asset {
    width: auto;
  }

  &__bg {
    object-fit: cover;
    position: absolute;
    width: 100%;
    display: block;
    top: 0;
    z-index: -1;
    height: 100%;
  }

  &__title {
    @include font-size(36, rem-v(54));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    margin: 0 0 spacer(4);
  }

  &__copy {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      list-style: none;
      margin-bottom: 2px;
      position: relative;
      padding: 24px 0 32px;

      &::before {
        background-color: $white;
        content: '';
        display: block;
        width: 30px;
        height: 1px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .capabilities {
    display: flex;

    &__container {
      display: flex;

      .row {
        align-content: center;
      }
    }

    &__copy {
      ul {
        padding: 0 0 0 54px;
      }
      li {
        padding: 11px 0;
        &::before {
          border-radius: 50%;
          content: '';
          display: block;
          height: 10px;
          left: -55px;
          top: 41%;
          position: absolute;
          width: 10px;
        }
      }
    }
  }
}
</style>
